import React from 'react'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from 'recharts'
import { formatScorecardDecimal } from 'helpers/scorecardFormat'

interface Props {
  chartData?: {
    name: any
    markTotal: any
    markScored: any
  }[]
  style?: React.CSSProperties
  totalItems?: number
}

const formatChartLabel = (value: number | string) => formatScorecardDecimal(value)

const CustomXAxisTick = (props: any) => {
  const { x, y, payload } = props
  const maxWidth = 120
  const minPadding = 5
  const words = payload.value.split(' ')
  const lines = []
  let currentLine = ''
  words.forEach((word: any) => {
    const testLine = currentLine.length === 0 ? word : `${currentLine} ${word}`
    const testWidth = testLine.length * 8

    if (testWidth > maxWidth) {
      lines.push(currentLine)
      currentLine = word
    } else {
      currentLine = testLine
    }
  })
  lines.push(currentLine)
  return (
    <g transform={`translate(${x},${y})`}>
      {lines.map((line, index) => (
        <text
          key={index}
          x={0}
          y={index * 1 + minPadding}
          dy={index > 0 ? 7 * index : 0}
          textAnchor="middle"
          fill="#666"
          fontWeight="bold"
          fontSize={7}
        >
          {line}
        </text>
      ))}
    </g>
  )
}

export const SectionTagChart: React.FC<Props> = ({ chartData = [], style, totalItems }) => {
  const maxDataValue = Math.max(...chartData.map(item => item.markTotal), ...chartData.map(item => item.markScored))
  const tickInterval = 5
  const yAxisTicks = Array.from({ length: Math.ceil(maxDataValue / tickInterval) + 1 }, (_, index) => index * tickInterval)
  return (
    <ResponsiveContainer width="100%" height={totalItems && totalItems > 4 ? 150 : 250}>
      <BarChart data={chartData} margin={{ top: 10, right: 30, left: 20, bottom: totalItems && totalItems > 4 ? 10 : 100 }} barGap={2}>
        <XAxis dataKey="name" tick={<CustomXAxisTick />} interval={0} />
        <YAxis ticks={yAxisTicks} />
        <Bar dataKey="markTotal" fill="#0C5692" barSize={20} name="Total Score Assigned">
          <LabelList dataKey="markTotal" position="top" formatter={formatChartLabel} style={{ fill: '#363535', fontSize: '10px' }} />
        </Bar>
        <Bar dataKey="markScored" fill="#96C63C" barSize={20} name="Total Score Scored">
          <LabelList dataKey="markScored" position="top" formatter={formatChartLabel} style={{ fill: '#363535', fontSize: '10px' }} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}
export default SectionTagChart
//-------------------------------------------------------------------------
// import React from 'react';
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   LabelList,
// } from 'recharts';
// interface Props {
//   chartData?: {
//     name: any;
//     markTotal: any;
//     markScored: any;
//   }[];
//   style?: React.CSSProperties;
// }
// export const SectionTagChart: React.FC<Props> = ({ chartData = [], style }) => {
//   // Find the maximum data value
//   const maxDataValue = Math.max(
//     ...chartData.map((item) => item.markTotal),
//     ...chartData.map((item) => item.markScored)
//   );
//   // Calculate the tick interval based on multiples of 5
//   const tickInterval = 5;
//   const yAxisTicks = Array.from(
//     { length: Math.ceil(maxDataValue / tickInterval) + 1 },
//     (_, index) => index * tickInterval
//   );
//   return (
//     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//       <div style={{ padding: '2rem', width: '90%' }}>
//         <BarChart width={350} height={300} data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 120 }}>
//           {/* <CartesianGrid strokeDasharray="3 3" /> */}
//           <XAxis
//             dataKey="name"
//             angle={-90}
//             textAnchor="end"
//             tick={{ fill: 'black', fontSize: 12 }}
//           />
//           <YAxis ticks={yAxisTicks} />
//           <Bar
//             dataKey="markTotal"
//             fill="#0C5692"
//             barSize={20}
//             name="Total Score Assigned"
//           >
//             <LabelList dataKey="markTotal" position="outside" style={{ fill: 'white' }} />
//           </Bar>
//           <Bar
//             dataKey="markScored"
//             fill="#96C63C"
//             barSize={20}
//             name="Total Score Scored"
//           >
//             <LabelList dataKey="markScored" position="outside" style={{ fill: 'white' }} />
//           </Bar>
//         </BarChart>
//       </div>
//     </div>
//   );
// };
// export default SectionTagChart;
//-----------------------------------------------------------------------------------------------------------------------
//commented combain chart of line chart and bar chart
// import React from 'react';
// import {
//   Chart as ChartJS,
//   LinearScale,
//   CategoryScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   Legend,
//   Tooltip,
//   LineController,
//   BarController,
// } from 'chart.js';
// import { Chart } from 'react-chartjs-2';
// // import faker from 'faker';
// interface Props{
//     chartData?:any[];
// }
// ChartJS.register(
//   LinearScale,
//   CategoryScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   Legend,
//   Tooltip,
//   LineController,
//   BarController
// );
// export const SectionTagChart:React.FC<Props>=({chartData})=> {
//   const labels= chartData?.map((items:any)=>items.name)
//     const data = {
//         labels,
//         datasets: [
//           {
//             type: 'line' as const,
//             label: 'Total Mark Assigned',
//             borderColor: 'rgb(255, 99, 132)',
//             borderWidth: 2,
//             fill: true,
//             data: chartData?.map((items:any)=>items.markTotal),
//             backgroundColor: 'rgb(255, 99, 132)',
//           },
//           {
//             type: 'bar' as const,
//             label: 'Total Mark Obtained',
//             backgroundColor: 'rgb(75, 192, 192)',
//             data: chartData?.map((items:any)=>items.markScored),
//             borderColor: 'white',
//             borderWidth: 2,
//             barThickness: 50,
//           },
//         ],
//       };
//     return (<Chart type='bar' data={data} />);
// }
//--------------------------------------------------------------------------------------------------------------------------
// import React from 'react'
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
// import { Doughnut } from 'react-chartjs-2'
// ChartJS.register(ArcElement, Tooltip, Legend)
// interface Props{
//     chartData?:any[];
// }
// export const SectionTagChart:React.FC<Props>=({chartData})=> {
//     const data = {
//         labels: chartData?.map((items:any)=>items.name),
//         datasets: [
//           {
//             label: '# of Votes',
//             data: [10,10,0,40,30,20],
//             // data: chartData?.map((items:any)=>items.markTotal),
//             backgroundColor: [
//               "rgba(255, 255, 255, 0.6)",
//               'rgba(255, 99, 132, 0.2)',
//               "rgba(255, 255, 255, 0.6)",
//               'rgba(54, 162, 235, 0.2)',
//               "rgba(255, 255, 255, 0.6)",
//               'rgba(255, 206, 86, 0.2)',
//               "rgba(255, 255, 255, 0.6)",
//               'rgba(75, 192, 192, 0.2)',
//               'rgba(153, 102, 255, 0.2)',
//               'rgba(255, 159, 64, 0.2)',
//             ],
//             borderColor: [
//               'rgba(255, 99, 132, 1)',
//               'rgba(54, 162, 235, 1)',
//               'rgba(255, 206, 86, 1)',
//               'rgba(75, 192, 192, 1)',
//               'rgba(153, 102, 255, 1)',
//               'rgba(255, 159, 64, 1)',
//             ],
//             borderWidth: 1,
//           },
//         ],
//       }
//     return (
//     <div>
//       <Doughnut data={data} />
//     </div>
//   )
// }